import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../store";
import { ColumnFilterProps, FilterOperator } from "../../types/filters";
import { Checkbox } from "../Checkbox";

export const BooleanFilter: React.FC<ColumnFilterProps> = ({
  tableName,
  fieldName,
  filterSelectorValue,
  filterUpdateAction,
}) => {
  const value = useSelector((state: RootState) => filterSelectorValue(state, fieldName));
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const applyFilter = (isActive: boolean | undefined) => {
    dispatch(
      filterUpdateAction({
        id: fieldName,
        name: fieldName,
        operator: FilterOperator.IsEqualTo,
        value: isActive,
      })
    );
  };

  return (
    <>
      <div>
        <Checkbox
          checked={value?.value === true}
          onChange={(e) => {
            applyFilter(e.target.checked ? true : undefined);
          }}
        />
        {t(`${tableName}.filters.${fieldName}True`)}
      </div>
      <div>
        <Checkbox
          checked={value?.value === false}
          onChange={(e) => {
            applyFilter(e.target.checked ? false : undefined);
          }}
        />
        {t(`${tableName}.filters.${fieldName}False`)}
      </div>
    </>
  );
};
